import React, { PureComponent } from 'react'
import { injectIntl, FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'
import { CSSTransition } from 'react-css-transition'
import Products from '../lib/products'
import AdultIcon from '../icons/adultIcon'
import ChildIcon from '../icons/childIcon'
import TransitionStyles from '../lib/transitionStyles'


class BookingPricing extends PureComponent {

  constructor(props) {
    super(props)
    this.state = {
      ageCategory: props.ageCategory
    }
  }

  getPrice(productId, skuId) {
    const { skus } = this.props
    if (skus.length === 0) {
      return " "
    }
    const { ageCategory } = this.state
    const productIdToUse = ageCategory === 'child'
      ? productId.replace('Adult', 'Child')
      : productId

    const product = Products.find(p => p.id === productIdToUse)
    return skus.find(s => s.id === product[skuId || 'skuId']).price / 100
  }

  setAgeCategory(ageCategory) {
    this.setState({ageCategory})
  }

  render() {
    const { skus } = this.props
    const { ageCategory } = this.state
    const isAdult = () => ageCategory === 'adult'
    const isChild = () => ageCategory === 'child'

    // Strange fix - throws an error in console without this (https://github.com/wikiwi/react-css-transition/issues/5)
    CSSTransition.childContextTypes = {}

    return (
      <div className="container mx-auto">
        <div className="flex flex-wrap">
          <div className="flex-grow">
            <h4 className="uppercase tracking-wide text-sky pl-4 md:pl-0">
              <FormattedMessage id="booking.pricingPage.membershipLabel" defaultMessage="Membership" />
            </h4>
            <h1 className="uppercase italic text-3xl md:text-5xl pl-4 md:pl-0">
              <FormattedMessage id="booking.pricingPage.pricesLabel" defaultMessage="Prices" />
            </h1>
          </div>
          <div className="flex flex-wrap items-center md:mr-12 pl-4 md:pl-0">
            <div className="mr-4 w-full sm:w-auto mb-4 md:mb-0">
              <FormattedMessage id="booking.pricingPage.pricesForLabel" defaultMessage="Show prices for" />
            </div>
            <button
              onClick={() => this.setAgeCategory('adult')}
              className={`${isAdult() ? 'text-harbor' : 'text-grey'} flex items-center text-grey mr-4`}
              type="button"
            >  
              <div className={`${isAdult() ? 'border-blue-darkest' : 'border-grey'} flex items-center justify-center mr-2 w-8 h-8 md:w-12 md:h-12 rounded-full border-2`}>
                <AdultIcon sizeCss="w-4 h-4 md:w-8 md:h-8" textCss={`${isAdult() ? 'text-harbor' : 'text-grey'}`} />
              </div>
              <div>
                <FormattedMessage id="booking.pricingPage.AdultLabel" defaultMessage="Adult" />
              </div>
            </button>
            <button
              onClick={() => this.setAgeCategory('child')}
              className={`${isChild() ? 'text-harbor' : 'text-grey'} flex items-center text-grey mr-4`}
              type="button"
            >
              <div className={`${isChild() ? 'border-blue-darkest' : 'border-grey'} flex items-center justify-center mr-2 w-8 h-8 md:w-12 md:h-12 rounded-full border-2`}>
                <ChildIcon sizeCss="w-4 h-4 md:w-8 md:h-8" textCss={`${isChild() ? 'text-harbor' : 'text-grey'}`} />
              </div>
              <div>
                <FormattedMessage id="booking.pricingPage.KidsLabel" defaultMessage="Kids < 10 years old" />
              </div>
            </button>
          </div>
        </div>

        <div id="pricing-scrollable" className="p-4 md:p-0 overflow-auto md:overflow-visible scrolling-touch">
          <div className="flex" style={{minWidth: '950px'}}>
            <div className="w-3/4 pr-6">
              <div className="flex flex-col shadow-md px-6">
                <h4 className="pt-8 pb-4 uppercase tracking-wide text-grass text-center">
                  <FormattedMessage id="booking.pricingPage.membershipLabel" defaultMessage="Membership" />
                </h4>
                <div className="flex">
                  <div className="flex flex-col w-1/3 px-3">
                    <h2 className="text-center h-16 mb-0">
                      <FormattedMessage id="booking.pricingPage.annualPassLabel" defaultMessage="Annual Pass" />
                    </h2>
                    <p className="text-grey-darker text-sm h-24 lg:h-16">
                      <FormattedMessage id="booking.pricingPage.annualPassDescription" defaultMessage="For you that wants unlimited skiing during weekdays and weekends along with all benefits, discounts and offers." />
                    </p>
                    <ul className="pl-0 text-harbor text-xs flex-grow">
                      <li className="pl-4"><FormattedMessage id="booking.pricingPage.booking.pricingPage.annualPassListitem1" defaultMessage="Newsletter with news & events" /></li>
                      <li className="pl-4"><FormattedMessage id="booking.pricingPage.booking.pricingPage.annualPassListitem2" defaultMessage="Benefit program" /></li>
                      <li className="pl-4"><FormattedMessage id="booking.pricingPage.booking.pricingPage.annualPassListitem3" defaultMessage="Free skiing time at CopenHill (weekdays)" /></li>
                      <li className="pl-4"><FormattedMessage id="booking.pricingPage.booking.pricingPage.annualPassListitem4" defaultMessage="Free skiing time at CopenHill (weekends)" /></li>
                      <li className="pl-4"><FormattedMessage id="booking.pricingPage.booking.pricingPage.annualPassListitem5" defaultMessage="Free Key Card" /></li>
                      {/* <li className="pl-4">Gratis to timers ski voucher til en ven (Early bird tilbud)</li> */}
                    </ul>
                    <CSSTransition {...TransitionStyles} transitionAppear active={skus.length !== 0}>
                      <div className="pt-4 pr-8 border-r text-center h-36">
                        <div className="leading-none">
                          <span className="text-5xl font-bold">
                            {this.getPrice('passAnnualAdultFull', 'hourRateWeekdaysSkuId')}
                          </span> 
                            &nbsp;<FormattedMessage id="booking.pricingPage.annualPassPerHourLabel" defaultMessage="DKK per hour" />
                        </div>
                        <div className="text-sky pb-8">
                          {this.getPrice('passAnnualAdultFull')}
                            &nbsp;&nbsp;<FormattedMessage id="booking.pricingPage.annualPassPerYearLabel" defaultMessage="DKK/year" />
                        </div>
                      </div>
                    </CSSTransition>
                  </div>
                  <div className="flex flex-col w-1/3 px-3">
                    <div className="h-16">
                      <h2 className="text-center mb-0">
                        <FormattedMessage id="booking.pricingPage.annualPassLabel" defaultMessage="Annual Pass" />
                      </h2>
                      <div className="text-center font-bold text-sky">
                        <FormattedMessage id="booking.pricingPage.annualPassWeekdaysLabel" defaultMessage="Week days" />
                      </div>
                    </div>
                    <p className="text-grey-darker text-sm h-24 lg:h-16">
                      <FormattedMessage id="booking.pricingPage.annualPassWeekdaysDescription" defaultMessage="For you that can’t get enough of skiing, benefits and further discounts" />
                    </p>
                    <ul className="pl-0 text-harbor text-xs flex-grow">
                      <li className="pl-4"><FormattedMessage id="booking.pricingPage.annualPassWeekdaysListitem1" defaultMessage="Annual PassNewsletter with news & events" /></li>
                      <li className="pl-4"><FormattedMessage id="booking.pricingPage.annualPassWeekdaysListitem2" defaultMessage="Benefit program" /></li>
                      <li className="pl-4"><FormattedMessage id="booking.pricingPage.annualPassWeekdaysListitem3" defaultMessage="Free skiing time at CopenHill (weekdays)" /></li>
                      <li className="pl-4"><FormattedMessage id="booking.pricingPage.annualPassWeekdaysListitem4" defaultMessage="Discount prices at CopenHill on weekends" /></li>
                      <li className="pl-4"><FormattedMessage id="booking.pricingPage.annualPassWeekdaysListitem5" defaultMessage="Free Key Card" /></li>
                      {/* <li className="pl-4">Gratis to timers ski voucher til en ven (Early bird tilbud)</li> */}
                    </ul>
                    <CSSTransition {...TransitionStyles} transitionAppear active={skus.length !== 0}>
                      <div className="pt-4 pr-8 border-r text-center h-36">
                        <div className="leading-none">
                          <span className="text-5xl font-bold">
                            {this.getPrice('passAnnualAdultWeekdays', 'hourRateWeekdaysSkuId')}
                          </span>
                            &nbsp;<FormattedMessage id="booking.pricingPage.annualPassPerHourLabel" defaultMessage="DKK per hour" />
                        </div>
                        <p className="text-xs m-0 mb-2">
                          (
                          <strong>
                            {this.getPrice('passAnnualAdultWeekdays', 'hourRateWeekendsSkuId')}
                          </strong>
                          &nbsp;<FormattedMessage id="booking.pricingPage.annualPassWeekdaysPerHourWeekend" defaultMessage="DKK per hour on weekends" />
                          )
                        </p>
                        <div className="text-sky pb-8">
                          {this.getPrice('passAnnualAdultWeekdays')}
                          &nbsp;<FormattedMessage id="booking.pricingPage.annualPassPerYearLabel" defaultMessage="DKK/year" />
                        </div>
                      </div>              
                    </CSSTransition>
                  </div>
                  <div className="flex flex-col w-1/3 px-3">
                    <h2 className="text-center h-16 mb-0">
                      <FormattedMessage id="booking.pricingPage.advantagePassLabel" defaultMessage="Advantage Pass" />
                    </h2>
                    <p className="text-grey-darker text-sm h-24 lg:h-16">
                      <FormattedMessage id="booking.pricingPage.advantagePassDescription" defaultMessage="For you that loves skiing and benefits" />
                    </p>
                    <ul className="pl-0 text-harbor text-xs flex-grow">
                      <li className="pl-4"><FormattedMessage id="booking.pricingPage.advantagePassListitem1" defaultMessage="Newsletter with news & events" /></li>
                      <li className="pl-4"><FormattedMessage id="booking.pricingPage.advantagePassListitem2" defaultMessage="Benefit program" /></li>
                      <li className="pl-4"><FormattedMessage id="booking.pricingPage.advantagePassListitem3" defaultMessage="Reduced price on ski time" /></li>
                      <li className="pl-4"><FormattedMessage id="booking.pricingPage.advantagePassListitem4" defaultMessage="Free Key Card" /></li>
                      {/* <li className="pl-4">Gratis to timers ski voucher til en ven (Early bird tilbud)</li> */}
                    </ul>
                    <CSSTransition {...TransitionStyles} transitionAppear active={skus.length !== 0}>
                      <div className="pt-4 pr-8 text-center h-36">
                        <div className="leading-none">
                          <span className="text-5xl font-bold">
                            {this.getPrice('passAnnualAdultAdvantage', 'hourRateWeekdaysSkuId')}
                          </span>
                          &nbsp;<FormattedMessage id="booking.pricingPage.annualPassPerHourLabel" defaultMessage="DKK per hour" />
                        </div>
                        <div className="text-sky pb-8">
                          {this.getPrice('passAnnualAdultAdvantage')}
                          &nbsp;<FormattedMessage id="booking.pricingPage.annualPassPerYearLabel" defaultMessage="DKK/year" />
                        </div>
                      </div>              
                    </CSSTransition>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex flex-col w-1/4 shadow-md px-6">
              <h4 className="pt-8 pb-4 uppercase tracking-wide text-grass text-center">
                <FormattedMessage id="booking.pricingPage.paymentPerHourLabel" defaultMessage="Payment per hour" />
              </h4>
              <h2 className="text-center h-16 mb-0">
                <FormattedMessage id="booking.pricingPage.basicPassLabel" defaultMessage="Basic Pass" />
              </h2>
              <p className="text-grey-darker text-sm h-24 lg:h-16">
                <FormattedMessage id="booking.pricingPage.basicPassDescription" defaultMessage="For you that wants to try out alpine ski sport" />
              </p>  
              <ul className="pl-0 text-harbor text-xs flex-grow">
                <li className="pl-4">
                  <FormattedMessage id="booking.pricingPage.basicPassListitem1" defaultMessage="One-time payment for Key Card: 50 DKK" />
                </li>
              </ul>            
              <CSSTransition {...TransitionStyles} transitionAppear active={skus.length !== 0}>
                <div className="pt-4 pr-8 text-center h-36">
                  <div className="leading-none">
                    <span className="text-5xl font-bold">
                      {this.getPrice('passHourlyAdult', 'hourRateWeekdaysSkuId')}
                    </span>
                    &nbsp;<FormattedMessage id="booking.pricingPage.annualPassPerHourLabel" defaultMessage="DKK per hour" />
                  </div>
                </div> 
              </CSSTransition>  
            </div>
          </div>

        </div>


      </div>
    )
  }
}

BookingPricing.propTypes = {
  skus: PropTypes.arrayOf(PropTypes.object),
  ageCategory: PropTypes.string
}

BookingPricing.defaultProps = {
  skus: [],
  ageCategory: 'adult'
}

export default injectIntl(BookingPricing)